<template>
  <v-container id="seo-section" fluid>
    <v-layout justify-center>
      <v-flex sm8 xs12>
        <v-layout justify-center>
          <v-flex text-center sm6 xs12>
            <p class="primary--text mt-md-10 mb-md-4 mb-1 hdr" v-html="title"></p>
          </v-flex>
        </v-layout>

        <v-layout col wrap pt-2> 
          <v-flex sm6 xs12 px-4>
            <v-layout column>
              <v-flex py-2>
                <ul>
                  <li
                    v-for="(line, index) in col1"
                    xs6
                    :key="index"
                    class="py-2 display-18"
                  >
                    <span v-html="line.text">{{ line.text }}</span>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex sm6 xs12 px-4>
            <v-layout column>
              <v-flex py-2>
                <ul>
                  <li
                    v-for="(line, index) in col2"
                    xs6
                    :key="index"
                    class="py-2 display-18"
                  >
                    <span v-html="line.text"></span>
                  </li>
                </ul>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout column justify-center>
      <v-flex text-center my-6>
        <p class="display-18 font-weight-medium">{{ title2 }}</p>
      </v-flex>
      <v-flex text-center mb-3>
        <DrBtn
          type-btn="orange_btn_large"
          go-to-url="/article/131/"
          target-url="_self"
        >
          {{ btn }}
        </DrBtn>
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>
export default {
  components: {},
  data() {
    return {
      col1: {
        1: {
          text: 'כפי שאתם יכולים לראות באתר, מעסיקים רבים מצהירים כי דרושים IL מהווה עבורם מקור הגיוס המוביל באינטרנט.',
        },
        2: {
          text: 'צוות האתר, המונה עשרות עובדים, מסייע באופן צמוד לאלפי מעסיקים בפרסום אלפי משרות כל חודש.',
        },
        3: {
          text: 'כשאתם שולחים קורות חיים למשרה המפורסמת באתר, אתם יכולים להיות בטוחים שמדובר במודעת דרושים רלוונטית ואמיתית אשר פורסמה ע"י המעסיק באופן ישיר.',
        },
      },
      col2: {
        1: {
          text: 'אנו לא מעתיקים משרות ממקורות אחרים! לכן אנו יכולים להבטיח כי פרטי יצירת הקשר של הגורם המגייס באותו ארגון הינם תקינים ועדכניים.',
        },
        2: {
          text: 'כל משרה באתר יורדת באופן אוטומטי, לאחר 30 יום. כך אנו מבטיחים את הרלוונטיות של כל המשרות המפורסמות באתר.',
        },
        3: {
          text: 'כל השירותים הניתנים באתר למחפשי עבודה הינם לגמרי בחינם: <a href="/smartalerts.aspx">סוכן חכם</a> | <a href="/personal/cvfiles.aspx">איזור אישי</a> | <a href="https://www.drushim.co.il/%D7%A7%D7%95%D7%A8%D7%95%D7%AA-%D7%97%D7%99%D7%99%D7%9D/">מערכת ליצירת קורות חיים</a>',
        },
      },

      title: `אז למה אנחנו אתר
              <br />
              הדרושים של ישראל?`,
      title2: 'מה עוד עושה אותנו לאתר הדרושים של ישראל?',
      btn: 'אני רוצה לדעת!',
    };
  },
};
</script>


<style lang="scss" scoped>
#seo-section {
  background: #f6f7f9;
  padding: 10px 0 40px;
}

.hdr {
  font-size: 30px;
  line-height: 1.1;
  @media only screen and (min-width: 600px) {
    font-size: 50px;
  }
}
</style>
